/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2025-05-09 11:00:00
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const GET_GENERAL_SWATCH_REQUEST = 'GET_GENERAL_SWATCH_REQUEST';
type GET_GENERAL_SWATCH_REQUEST_TYPE = 'GET_GENERAL_SWATCH_REQUEST';
export const GET_GENERAL_SWATCH_SUCCESS = 'GET_GENERAL_SWATCH_SUCCESS';
type GET_GENERAL_SWATCH_SUCCESS_TYPE = 'GET_GENERAL_SWATCH_SUCCESS';
export const GET_GENERAL_SWATCH_FAILURE = 'GET_GENERAL_SWATCH_FAILURE';
type GET_GENERAL_SWATCH_FAILURE_TYPE = 'GET_GENERAL_SWATCH_FAILURE';

type GetGeneralSwatchRequestAction = Action<GET_GENERAL_SWATCH_REQUEST_TYPE, null>;
type GetGeneralSwatchSuccessAction = Action<
  GET_GENERAL_SWATCH_SUCCESS_TYPE,
  CSATAdminAppDisplay
>;
type GetGeneralSwatchFailureAction = Action<
  GET_GENERAL_SWATCH_FAILURE_TYPE,
  { error: any }
>;

export const GET_GENERAL_SWATCH_SETTINGS_REQUEST = 'GET_GENERAL_SWATCH_SETTINGS_REQUEST';
type GET_GENERAL_SWATCH_SETTINGS_REQUEST_TYPE = 'GET_GENERAL_SWATCH_SETTINGS_REQUEST';
export const GET_GENERAL_SWATCH_SETTINGS_SUCCESS = 'GET_GENERAL_SWATCH_SETTINGS_SUCCESS';
type GET_GENERAL_SWATCH_SETTINGS_SUCCESS_TYPE = 'GET_GENERAL_SWATCH_SETTINGS_SUCCESS';
export const GET_GENERAL_SWATCH_SETTINGS_FAILURE = 'GET_GENERAL_SWATCH_SETTINGS_FAILURE';
type GET_GENERAL_SWATCH_SETTINGS_FAILURE_TYPE = 'GET_GENERAL_SWATCH_SETTINGS_FAILURE';

type GetGeneralSwatchSettingsRequestAction = Action<GET_GENERAL_SWATCH_SETTINGS_REQUEST_TYPE, null>;
type GetGeneralSwatchSettingsSuccessAction = Action<
  GET_GENERAL_SWATCH_SETTINGS_SUCCESS_TYPE,
  CSATAdminAppDisplay
>;
type GetGeneralSwatchSettingsFailureAction = Action<
  GET_GENERAL_SWATCH_SETTINGS_FAILURE_TYPE,
  { error: any }
>;

export const UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST = 'UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST';
type UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST_TYPE = 'UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST';

export const UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS = 'UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS';
type UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS_TYPE = 'UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS';

export const UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE = 'UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE';
type UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE_TYPE = 'UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE';

type SwatchSettingsSuccess = {
  data: Object
};

type SwatchSettingsFailure = {
  error: any
};
type UpdateGeneralSwatchSettingsRequestAction = Action<UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST_TYPE, null>;

type UpdateGeneralSwatchSettingsSuccessAction = Action<
  UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS_TYPE,
  SwatchSettingsSuccess
>;

type UpdateGeneralSwatchSettingsFailureAction = Action<
  UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE_TYPE,
  SwatchSettingsFailure
>;


export type GeneralSwatchAction =
  | GetGeneralSwatchRequestAction
  | GetGeneralSwatchSuccessAction
  | GetGeneralSwatchFailureAction
  | GetGeneralSwatchSettingsRequestAction
  | GetGeneralSwatchSettingsSuccessAction
  | GetGeneralSwatchSettingsFailureAction
  | UpdateGeneralSwatchSettingsRequestAction
  | UpdateGeneralSwatchSettingsSuccessAction
  | UpdateGeneralSwatchSettingsFailureAction;


export interface DataSwatchSettings {
  name: string;
  category: string;
  imageUrl: string;
  metafieldId: number;
  type: string;
  colorCodes: string[] | undefined;
  id?: string;
  tenantId?: string;
  updatedAt?: number;
}

export interface GeneralSwatch {
  name: string;
  originalName: string;
  type: string;
}

export interface GeneralSwatchSettings {
  data: DataSwatchSettings[];
  total: number;
}

export type GeneralSwatchState = {
  loading: boolean;
  success: boolean;
  error: any;
  loadingSwatchSettings: boolean;
  successSwatchSettings: boolean;
  errorSwatchSettings: any;
  generalSwatch: GeneralSwatch[];
  generalSwatchSettings: GeneralSwatchSettings | null;
};


export interface DataSwatchSettingsForm extends DataSwatchSettings {
  colorCode01?: string;
  colorCode02?: string;
}

export const RATING_STATUS = {
  COMPLETE: 'complete',
  IN_COMPLETE: 'incomplete'
}

export const RATING_TYPE = {
  DASHBOARD: 'dashboard',
  ONBOARDING: 'onboarding'
}